import { get } from "../../../utils/object-helpers";

$ {
    const isSmall = get(input, 'page.isSmall', false);
    const manageStoreUrl = get(input, 'manageStoreAction.action.URL', '');
    const manageStoreText = get(input, 'manageStoreAction.text', '');
    const bannerURL = get(input, 'banner.URL', '');
}

<if(!isSmall && manageStoreUrl !== '' && manageStoreText !== '')>
    <${bannerURL !== '' ? null : 'div'} class="str-header__manage-store-wrap">
        <ebay-button href=manageStoreUrl class="str-header__manage-store black-btn" priority="primary">
            ${manageStoreText}
        </ebay-button>
    </>
</if>
